angular.module('TInv.dir.files', []
).directive('fileBase64', function () {
    return {
        restrict: 'A',
        scope: {
            fileBase64: '=',
            fileName: '=?',
            fileStatus: '=?',
        },
        link: function (scope, element) {
            var valid = /^data:application\/pdf;base64,(JVBERi0.*)/; // decoded content starts with '%PDF-'
            element.bind('change', function () {
                var file = element[0].files[0],
                    reader = new FileReader();
                reader.onload = function () {
                    var m = valid.exec(reader.result);
                    if (m) {
                        scope.fileBase64 = m[1];
                        scope.fileName = file.name;
                        scope.fileStatus = 'Caricato un PDF di ' + Math.round(m[1].length*6/8192) + ' KiB';
                    } else {
                        scope.fileBase64 = null;
                        scope.fileStatus = 'Il file non sembra essere un PDF.';
                    }
                    element.val(null);
                    scope.$apply();
                };
                reader.onerror = function () {
                    scope.fileBase64 = null;
                    scope.fileStatus = 'Impossibile leggere il file.';
                    scope.$apply();
                };
                reader.readAsDataURL(file);
            });
        }
    };
}).directive('fileAdd', function ($log) {
    return {
        restrict: 'A',
        scope: {
            fileAdd: '=',
        },
        link: function (scope, element) {
            if (element[0].tagName.toUpperCase() == 'INPUT' && element[0].type.toUpperCase() == 'FILE')
                element.on('change', function () {
                    scope.fileAdd([].slice.call(element[0].files));
                });
            element.on('dragover', function (e) {
                e.preventDefault();
                e.stopPropagation();
                var hasFiles = false;
                if (e.dataTransfer.items)
                    [].forEach.call(e.dataTransfer.items, function (i) {
                        if (i.kind == 'file')
                            hasFiles = true;
                    });
                else
                    [].forEach.call(e.dataTransfer.files, function () {
                        hasFiles = true;
                    });
                $log.debug('Over (' + hasFiles + ' files):', e.dataTransfer);
                e.dataTransfer.dropEffect = hasFiles ? 'copy' : 'none';
            });
            element.on('drop', function (e) {
                e.preventDefault();
                e.stopPropagation();
                $log.info('Drop:', e.dataTransfer);
                if (e.dataTransfer.items)
                    [].forEach.call(e.dataTransfer.items, function (i) {
                        $log.info('Item:', i);
                        if (i.kind == 'file')
                            scope.fileAdd([i.getAsFile()]);
                    });
                else
                    scope.fileAdd([].slice.call(e.dataTransfer.files));
            });
        }
    };
});
